import styled from '@emotion/styled';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CenterRowWrapper, Row } from '../core/layouts/CommonLayoutStyles';
import { InlineBodyMedium, LandingTextButton } from '../core/text/LandingTypography';
import ActivateLicenseDialog from './ActivateLicenseDialog';

interface IActivateLicenseMinorCTAProps {
    center?: boolean;
    organizationId?: string;
}
export default function ActivateLicenseMinorCTA({ center = true, organizationId }: IActivateLicenseMinorCTAProps) {
    const { t } = useTranslation();
    const [showDialog, setShowDialog] = useState(false);
    const currentUser = useCurrentUserStore((state) => state.currentUser);

    const onClick = () => {
        setShowDialog(true);
    };

    const onCancel = () => {
        setShowDialog(false);
    };

    const RowWrapper = center ? CenterRowWrapper : StyledRow;

    if (!currentUser?.isEmailVerified) {
        return null;
    }

    return (
        <>
            <RowWrapper>
                <InlineBodyMedium>{t('common:license.activate.question')}</InlineBodyMedium>
                <LandingTextButton $color="context" onClick={onClick}>
                    {t('common:license.activate.button')}
                </LandingTextButton>
            </RowWrapper>
            <ActivateLicenseDialog open={showDialog} onCancel={onCancel} organizationId={organizationId} />
        </>
    );
}

const StyledRow = styled(Row)`
    align-items: center;
    justify-content: flex-start;
`;
